import { asyncSessionStorage } from '../../admin/store'

/**
 * Redirect to remote login back link
 *
 * @param {Object} userTokens
 * @return {Promise<unknown>}
 */
export const redirectToRemoteLoginBacklink = userTokens => (
    asyncSessionStorage.getItem('sportnect.remoteLoginBacklink')
        .then(backlink => (
            asyncSessionStorage.removeItem('sportnect.remoteLoginBacklink')
                .then(() => new Promise(resolve => resolve(backlink)))
        ))
        .then(backlink => {
            if (backlink && backlink !== '') {
                let mergeChar = '?'

                const backlinkSearch = (new URL(backlink))?.search
                if (backlinkSearch && backlinkSearch !== '') {
                    mergeChar = '&'
                }

                window.location.href = `${backlink}${mergeChar}sntokens=${window.btoa(JSON.stringify(userTokens))}`

                return new Promise(resolve => resolve())
            }

            return new Promise((resolve, reject) => reject())
        })
)

/**
 * Get absolute URL address to remote login link with redirect back
 *
 * @return {string}
 */
export const getRemoteLoginLink = () => {
    const redirectLink = window.location.href
    const {
        REACT_APP_SPORTNECT_URL: sportnectUrl,
        REACT_APP_FRONTEND_URL: frontendUrl,
    } = window.APP_CONFIG

    return `${sportnectUrl}remote-login?backlink=${frontendUrl}/remote-logged%3Fredirect=${window.btoa(redirectLink)}`
}
